module.exports = __webpack_public_path__ + "static/media/facebookIcon.a8537481.png";